export const darkTokens = {
  '--bg-primary': '#0A0E14',
  '--bg-secondary': '#141B22',
  '--bg-tertiary': '#1A232E',
  '--bg-hover': '#1E2A38',
  '--border': '#2A3544',
  '--border-subtle': '#1E2A38',
  '--text-primary': '#E6EDF3',
  '--text-secondary': '#8B949E',
  '--text-muted': '#5C6975',
  '--accent': '#2DD4BF',
  '--accent-hover': '#5EEAD4',
  '--accent-muted': 'rgba(45, 212, 191, 0.15)',
  '--bullish': '#4ADE80',
  '--bearish': '#F87171',
  '--warning': '#FBBF24',
  '--chart-bg': '#0A0E14',
  '--chart-grid': '#1A232E',
  '--chart-crosshair': '#5C6975',
  '--sidebar-bg': '#0D1117',
  '--sidebar-border': '#1E2A38',
  '--footer-bg': '#0D1117',
} as const;

export const lightTokens = {
  '--bg-primary': '#F4F6F9',
  '--bg-secondary': '#E4E9EF',
  '--bg-tertiary': '#D6DDE5',
  '--bg-hover': '#CCD5DF',
  '--border': '#BAC4CF',
  '--border-subtle': '#CFD6DF',
  '--text-primary': '#1A2330',
  '--text-secondary': '#46505E',
  '--text-muted': '#67707C',
  '--accent': '#0D9488',
  '--accent-hover': '#14B8A6',
  '--accent-muted': 'rgba(13, 148, 136, 0.1)',
  '--bullish': '#16A34A',
  '--bearish': '#DC2626',
  '--warning': '#D97706',
  '--chart-bg': '#FFFFFF',
  '--chart-grid': '#DCE3EB',
  '--chart-crosshair': '#67707C',
  '--sidebar-bg': '#E4E9EF',
  '--sidebar-border': '#CFD6DF',
  '--footer-bg': '#E4E9EF',
} as const;

export type ThemeTokens = typeof darkTokens;
export type ThemeName = 'dark' | 'light';
